import { FunctionComponent, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./CheckoutPagamentoAprovado.module.css";
import { Header } from "../../components/Header";
import { useCheckout } from "../../context/CheckoutContext";
import { ecommerceEvents } from "../../utils/gtm";

const CheckoutPagamentoAprovado: FunctionComponent = () => {
  const navigate = useNavigate();
  const params = useParams();

  const { cart, cleanCart, totalPrice, coupon, planName, saleId, setCard, card } = useCheckout();
  
  useEffect(() => {
    setCard({...card, security_code: ''})
        ecommerceEvents.purchase({
          currency: "BRL",
          value: totalPrice,
          transaction_id: saleId,
          items: cart.map(item => ({
            item_id: item.id,
            item_name: item.title,
            price: item.price,
            quantity: item.quantity,
            coupon: coupon?.name,
            item_list_name: planName,
          })),
        });
    
    if (cart.length === 0) params.slug ? navigate(`/${params.slug}`) : navigate("/")
  }, [])

  return (
    <div className={styles.checkoutPagamentoAprovado}>
      <div className={styles.header}>
        <Header path="none" />
      </div>
      <div className={styles.aprovado}>
        <img
          className={styles.httpslottiefilescomanimatIcon}
          alt=""
          src="/httpslottiefilescomanimationschecko5qz0wnuw2@2x.png"
        />
        <div className={styles.info}>
          <div className={styles.pagamentoAprovadoParent}>
            <div className={styles.pagamentoAprovado}>Pagamento aprovado!</div>
            <div className={styles.suaMaquinhaChegar}>
              Sua maquinha chegará em até:
            </div>
          </div>
          <div className={styles.iconesParent}>
            <img className={styles.icones} alt="" src="/icones10.svg" />
            <div className={styles.sudesteSulEContainer}>
              <p className={styles.nordesteENorte520DiasT}>
                <span>{`Sudeste, sul e centro-oeste: `}</span>
                <span className={styles.diasTeis}>2-15 dias úteis*</span>
              </p>
              <p className={styles.nordesteENorte520DiasT}>
                <span>{`Nordeste e norte: `}</span>
                <span className={styles.diasTeis}>5-20 dias úteis*</span>
              </p>
            </div>
          </div>
        </div>
        <div className={styles.teEnviamosUmContainer}>
          <p className={styles.nordesteENorte520DiasT}>
            Te enviamos um e-mail com todos os dados da sua compra para sua
            segurança.
          </p>
          <p className={styles.nordesteENorte520DiasT}>
            {`Em caso de dúvidas, entre em `}
            <a
              className={styles.contatoComANossaEquipe}
              href="https://yelly.com.br/#:~:text=Pol%C3%ADtica%20de%20Privacidade-,Contato,-contato%40yellyfintech.com"
              target="_blank" rel="noreferrer"
            >
              <span className={styles.contatoComA}>
                contato com a nossa equipe
              </span>
            </a>
          </p>
        </div>
        <a className={styles.cta} href="https://conta.yelly.com.br/register" target="_blank" rel="noreferrer">
          <img className={styles.icones3} alt="" src="/icones4.svg" />
          <div className={styles.pagamentoAprovado}>PROSSEGUIR PARA O CADASTRO</div>
          <img className={styles.icones1} alt="" src="/icones5.svg" />
        </a>
        <div className={styles.teEnviamosUmContainer}>
        <div className={styles.nordesteENorte520DiasT}>
          * É necessário efetuar o cadastro no portal Yelly e ter os documentos aprovados para que os equipamentos sejam enviados.
        </div>
        </div>
        <a href="https://api.whatsapp.com/send?phone=5527996075780" target="_blank" rel="noreferrer"><img className={styles.logoYellyIcon} src="/whatz.svg" ></img></a>
        <div className={styles.cta} onClick={() => {
          cleanCart()
          params.slug ? navigate(`/${params.slug}`) : navigate('/')
        }}>
          <img className={styles.icones3} alt="" src="/icones4.svg" />
          <div className={styles.pagamentoAprovado}>Voltar para o início</div>
          <img className={styles.icones1} alt="" src="/icones5.svg" />
        </div>
      </div>
    </div>
  );
};

export default CheckoutPagamentoAprovado;
